import moment from 'moment';

export const mapActiveItemToState = (item) => {
  const { vendorServiceCategoryNames } = item;
  return {
    ...item,
    vendorServiceCategoryIds: vendorServiceCategoryNames.map(
      (item) => item.offerServiceCategoryId
    ),
    selectedCategories: {
      serviceCategoryId: vendorServiceCategoryNames[0]?.offerServiceCategoryId,
      serviceCategoryName:
        vendorServiceCategoryNames[0]?.offerServiceCategoryName,
    },
    selectedService: {
      vendorServiceId: item.vendorServiceId,
      serviceType: item.vendorServiceName,
    },
    selectedStatus: {
      lookupItemId: item.offerStatusId,
      lookupItemName: item.offerStatusName,
    },
    files: item.qrFileId && [
      { fileName: `${item.promoCode} qr code`, uuid: item.qrFileId },
    ],
  };
};

export const mapStateToActiveItem = (state) => {
  const {
    files,
    selectedStatus,
    selectedService,
    selectedCategories,
    vendorServiceCategoryNames,
    ...rest
  } = state;
  return rest;
};
